<template>
  <div class="barscan-cnt">
    <header class="inner-header">
      <span class="icon-Btn go-back" @click="$router.go(-1)">
        <ArrowLeftBackIcon />
      </span>
      <h1>बारकोड स्कैन करे</h1>
    </header>

    <ul class="tab-type">
      <li
        @click="tabStatus = 'scan_barcode'"
        :class="tabStatus === 'scan_barcode' ? 'selected-tab' : ''"
      >
        Scan Barcode
      </li>
      <li
        @click="tabStatus = 'scanned_product'"
        :class="tabStatus === 'scanned_product' ? 'selected-tab' : ''"
      >
        Scanned Products
      </li>
    </ul>

    <div class="mid-cnt">
      <ScanBarCode v-if="tabStatus === 'scan_barcode'" @activeScannedTab="scannedTabActive" />
      <ScannedProductList v-if="tabStatus === 'scanned_product'"  />
    </div>
  </div>
</template>
<script>
import '../assets/css/product-barscan.scss';
import ArrowLeftBackIcon from '@/components/Icons/ArrowLeftBackIcon';
import SearchIcon from '@/components/Icons/SearchIcon';
import CloseIcon from '@/components/Icons/CloseIcon';
import ScannedProductList from '@/components/BarCodeScan/ScannedProductList';
import ScanBarCode from '@/components/BarCodeScan/ScanBarCode';

export default {
  name: 'ProductBarScan',
  data() {
    return {
      tabStatus: 'scan_barcode',
    };
  },
  components: {
    ArrowLeftBackIcon,
    SearchIcon,
    CloseIcon,
    ScannedProductList,
    ScanBarCode,
  },
  watch: {},
  methods: {
    scannedTabActive(){
      this.tabStatus = 'scanned_product'
    }
  },
  mounted() {},
};
</script>
